import React from 'react';
import '../../styles/modern-theme.css';

interface ModernStatCardProps {
    label: string;
    value: string | number;
    change?: string;
    isNegative?: boolean;
    onClick?: () => void;
    className?: string;
}

const ModernStatCard: React.FC<ModernStatCardProps> = ({
    label,
    value,
    change,
    isNegative = false,
    onClick,
    className = ''
}) => {
    return (
        <div 
            className={`modern-stat-card ${onClick ? 'cursor-pointer' : ''} ${className}`}
            onClick={onClick}
            style={onClick ? { cursor: 'pointer' } : undefined}
        >
            <div className="modern-stat-label">{label}</div>
            <div className="modern-stat-value">{value}</div>
            {change && (
                <div className={`modern-stat-change ${isNegative ? 'negative' : ''}`}>
                    {change}
                </div>
            )}
        </div>
    );
};

export default ModernStatCard;
